import style from "./WhiteBtn.module.css";

function WhiteBtn(props) {
  var className = style.WhiteBtn + " ";
  if (props.className) {
    className += props.className;
  }
  return (
    <button className={className} onClick={props.onClick}>
      <props.variant className={style.WhiteBtnTxt}>
        {props.children}
      </props.variant>
    </button>
  );
}

export default WhiteBtn;
